/**
 * SessionPanel constants and helpers
 */

/** Sentinel value for "current" session (not yet persisted) */
export const SENTINEL = "current";

/** Check if a session ID is a real persisted ID (not SENTINEL or empty) */
export function isRealSessionId(s?: string | null): s is string {
  return !!s && s !== SENTINEL;
}

/** Get today's date in ISO format (YYYY-MM-DD) */
export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Generate a local session ID (crypto.randomUUID with fallback) */
export function generateLocalSessionId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ||
    `sid_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
  );
}
